import CountryFlag from './CountryFlag.vue';

export default CountryFlag;
